import { useSyncExternalStore } from "react";

const KEY = "mp_odds";
const listeners = new Set();
export const ODDS_FORMATS = [["decimal", "Decimal (1.90)"], ["american", "American (-111)"], ["fractional", "Fractional (9/10)"]];

// Decimal everywhere by default; American/fractional are opt-in preferences only.
export const DEFAULT_ODDS_FORMAT = "decimal";

export const getOddsFormat = () => localStorage.getItem(KEY) || DEFAULT_ODDS_FORMAT;
export function setOddsFormat(f) {
  if (f) localStorage.setItem(KEY, f); else localStorage.removeItem(KEY);
  listeners.forEach((l) => l());
}
export function useOddsFormat() {
  const format = useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, getOddsFormat);
  return { format, setFormat: setOddsFormat, isManual: !!localStorage.getItem(KEY) };
}

export function toAmerican(dec) {
  if (!(dec > 1)) return "—";
  const v = dec >= 2 ? Math.round((dec - 1) * 100) : -Math.round(100 / (dec - 1));
  return v > 0 ? `+${v}` : `${v}`;
}

// Standard bookmaker fractions; falls back to the closest fraction with a small denominator.
const BOOK_FRACTIONS = [[1, 10], [1, 8], [1, 6], [1, 5], [2, 9], [1, 4], [2, 7], [3, 10], [1, 3], [4, 11], [2, 5], [4, 9], [1, 2], [8, 15], [4, 7], [8, 13], [4, 6], [8, 11], [4, 5], [5, 6], [10, 11], [9, 10], [1, 1], [11, 10], [6, 5], [5, 4], [11, 8], [6, 4], [13, 8], [7, 4], [15, 8], [2, 1], [9, 4], [5, 2], [11, 4], [3, 1], [10, 3], [7, 2], [4, 1], [9, 2], [5, 1], [11, 2], [6, 1], [13, 2], [7, 1], [15, 2], [8, 1], [9, 1], [10, 1], [12, 1], [14, 1], [16, 1], [20, 1], [25, 1], [33, 1], [50, 1], [100, 1]];
export function toFractional(dec) {
  if (!(dec > 1)) return "—";
  const target = dec - 1;
  let best = null;
  for (const [n, d] of BOOK_FRACTIONS) {
    const err = Math.abs(n / d - target) / target;
    if (!best || err < best.err) best = { n, d, err };
  }
  if (best.err <= 0.015) return `${best.n}/${best.d}`;
  for (let d = 1; d <= 20; d++) {
    const n = Math.round(target * d);
    if (n > 0 && Math.abs(n / d - target) / target <= 0.01) return `${n}/${d}`;
  }
  return `${Math.round(target * 100)}/100`;
}

export function fmtOdds(dec, format) {
  const v = Number(dec);
  if (!Number.isFinite(v)) return "—";
  if (format === "american") return toAmerican(v);
  if (format === "fractional") return toFractional(v);
  return v.toFixed(2);
}
